// Copyright (c) 2021, 37.78 Tecnologia Ltda. All rights reserved.

import React from "react";

import { Box, styled } from "@3778.care/goban";
import { Outlet } from "react-router-dom";

import { useIsDesktop } from "../../util/useIsDesktop";
import { BottomNavigation } from "./BottomNavigation";
import { Toolbar } from "./Toolbar";

const Children = styled(Box)(({ theme: { breakpoints, spacing } }) => ({
  paddingBottom: spacing(7),
  [breakpoints.up("md")]: {
    paddingTop: spacing(8),
    paddingBottom: spacing(0),
  },
}));

export const ApplicationLayout = () => {
  const isDesktop = useIsDesktop();

  return (
    <>
      {isDesktop && <Toolbar />}
      <Children>
        <Outlet />
      </Children>
      {!isDesktop && <BottomNavigation />}
    </>
  );
};
